import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export function CreditometerIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_2340_2993" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16"><rect width="16" height="16" fill="#D9D9D9" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_2340_2993)"><path d="M3.39967 13.3332C3.15523 13.3332 2.93023 13.2804 2.72467 13.1748C2.51912 13.0693 2.35523 12.9109 2.23301 12.6998C1.94412 12.1776 1.7219 11.6359 1.56634 11.0748C1.41079 10.5137 1.33301 9.93317 1.33301 9.33317C1.33301 8.41095 1.50801 7.54428 1.85801 6.73317C2.20801 5.92206 2.68301 5.2165 3.28301 4.6165C3.88301 4.0165 4.58856 3.5415 5.39967 3.1915C6.21079 2.8415 7.07745 2.6665 7.99968 2.6665C8.25523 2.6665 8.51079 2.68317 8.76634 2.7165C9.0219 2.74984 9.27745 2.79428 9.53301 2.84984L8.64968 4.04984C8.53856 4.02762 8.43023 4.01373 8.32468 4.00817C8.21912 4.00262 8.11079 3.99984 7.99968 3.99984C6.51079 3.99984 5.24967 4.5165 4.21634 5.54984C3.18301 6.58317 2.66634 7.84428 2.66634 9.33317C2.66634 9.79984 2.73023 10.2582 2.85801 10.7082C2.98579 11.1582 3.16634 11.5887 3.39967 11.9998H12.583C12.8275 11.5998 13.0108 11.1721 13.133 10.7165C13.2552 10.2609 13.3163 9.79984 13.3163 9.33317C13.3163 8.59984 13.1747 7.89984 12.8913 7.23317C12.608 6.5665 12.1997 5.98317 11.6663 5.48317L12.0163 4.03317C12.8497 4.6665 13.4969 5.44706 13.958 6.37484C14.4191 7.30262 14.6497 8.28873 14.6497 9.33317C14.6608 9.93317 14.5886 10.5165 14.433 11.0832C14.2775 11.6498 14.0497 12.1887 13.7497 12.6998C13.6275 12.9109 13.4636 13.0693 13.258 13.1748C13.0525 13.2804 12.8275 13.3332 12.583 13.3332H3.39967ZM7.44968 10.5332C7.80523 10.6887 8.16356 10.6971 8.52468 10.5582C8.88579 10.4193 9.1219 10.1665 9.23301 9.79984C9.55523 8.72206 9.8469 7.64428 10.108 6.5665C10.3691 5.48873 10.6052 4.39984 10.8163 3.29984C10.1163 4.17762 9.43579 5.06095 8.77468 5.94984C8.11356 6.83873 7.46079 7.74428 6.81634 8.6665C6.59412 8.98873 6.54967 9.33873 6.68301 9.7165C6.81634 10.0943 7.0719 10.3665 7.44968 10.5332Z" fill="#DDFA88" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t1}{t2}</svg>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}